import { ILogger } from './types';
import loadAgentFromCDN from '@tr-digital/appdynamics-client-agent';
import { v4 as uuid } from 'uuid';

declare global {
  interface Window {
    ADRUM: { report: (err: any) => void; events: any };
  }
}

export default class AppDynamicsLogger implements ILogger {
  constructor(apiKey: string, identifier?: string) {
    if (!apiKey) {
      throw new Error('apiKey is required');
    }

    this.identifier = identifier || uuid();

    loadAgentFromCDN(apiKey, 'SPA');
  }

  private identifier: string;

  // this method responsibility is to create the log message using AppDynamics SDK
  // and report it by using ADRUM global object.
  // ADRUM is AppDynamics client agent object that provides monitor and log capabilities.
  private logMessage = (
    msg: string = '',
    logLevel: string,
    stack?: string,
    ...optionalParams: any[]
  ) => {
    const errorT = new window.ADRUM.events.Error();

    const framedMsg = this.buildMessage(msg, optionalParams);
    errorT.msg(`${framedMsg}\nlog-level: ${logLevel}`);

    errorT.url(window.location.href);
    errorT.line(0);
    errorT.stack(stack || '');
    window.ADRUM.report(errorT);
  };

  private buildMessage = (msg?: string, ...optionalParams: any[]): string => {
    if (!optionalParams || !optionalParams.length) {
      return msg || '';
    }

    const stringifiedParams: string[] = optionalParams.reduce(
      (msgAccumaltor, param) => {
        msgAccumaltor.push(JSON.stringify(param));
        return msgAccumaltor;
      },
      []
    );
    const framedMsg = `${msg || ''}\nparams: ${stringifiedParams.join(' ')}`;
    return framedMsg;
  };

  public debug = (msg?: string, ...optionalParams: any[]): void => {
    this.logMessage(msg, 'Debug', '', optionalParams);
  };

  public info = (msg?: string, ...optionalParams: any[]): void => {
    this.logMessage(msg, 'Info', '', optionalParams);
  };

  public warn = (msg?: string, ...optionalParams: any[]): void => {
    this.logMessage(msg, 'Warn', '', optionalParams);
  };

  public error = (ex: Error, ...optionalParams: any[]): void => {
    const msg = `session-id: ${this.identifier}\nmsg: ${ex.message}\nstack: ${ex.stack}`;
    this.logMessage(msg, 'Error', ex.stack, optionalParams);
  };

  public trace = (msg?: string, ...optionalParams: any[]): void => {
    this.logMessage(msg, 'Trace', '', optionalParams);
  };
}
